"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressHeader = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var ArrowLeft_1 = require("../../icons/outline/ArrowLeft");
var Text_1 = require("../Text");
var IconButton_1 = require("../IconButton");
var colors_1 = require("../../colors");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    root: {
        height: 56,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: (0, colors_1.getColor)('WHITE_100'),
    },
    buttonMargin: { marginRight: 22 },
    progressBar: {
        margin: '0 auto',
        width: 287,
        height: 12,
        borderRadius: 100,
        backgroundColor: (0, colors_1.getColor)('GRAY_BG'),
    },
    status: function (props) { return ({
        width: props.progress === 0 ? 26 : "".concat(props.progress * 100, "%"),
        height: 12,
        borderRadius: 100,
        backgroundColor: (0, colors_1.getColor)('PURPLE_100'),
    }); },
}); });
var ProgressHeader = function (_a) {
    var onClick = _a.onClick, progress = _a.progress, _b = _a.hideProgress, hideProgress = _b === void 0 ? false : _b, children = _a.children, className = _a.className;
    var classes = useStyles({ progress: progress });
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.root, className) },
        react_1.default.createElement(IconButton_1.IconButton, { stylesProps: {
                backgroundColor: 'WHITE_100',
                color: 'BLACK_100',
                withShadow: false,
                size: 40,
            }, className: classes.buttonMargin, onClick: onClick, icon: react_1.default.createElement(ArrowLeft_1.ArrowLeft, null) }),
        children && (react_1.default.createElement(Text_1.Text, { variant: 'small', color: 'BLACK_100' }, children)),
        !hideProgress && (react_1.default.createElement("div", { className: classes.progressBar },
            react_1.default.createElement("div", { className: classes.status })))));
};
exports.ProgressHeader = ProgressHeader;
